import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import TicketDetailView from './TicketDetailView';

/** Full-screen dialog wrapper — used for creating new tickets only. */
export default function TicketDetailModal({
  open,
  onClose,
  ticketFormReadOnly,
  formTitle,
  onFormTitleChange,
  formBody,
  onFormBodyChange,
  formStatus,
  onFormStatusChange,
  formPriority,
  onFormPriorityChange,
  formAppId,
  onFormAppIdChange,
  ticketApps = [],
  forceAppSelection = false,
  formTargetRepoKey = '',
  onFormTargetRepoKeyChange,
  formLinkedReadRepoKeys = [],
  onFormLinkedReadRepoKeysChange,
  gameProjectsWithGithub = [],
  appProjectsWithGithub = [],
  formLabelIds,
  onFormLabelIdsChange,
  formAssignee,
  onFormAssigneeChange,
  formAiSpendOverrideCalls = '',
  onFormAiSpendOverrideCalls,
  formAiSpendOverrideSpend = '',
  onFormAiSpendOverrideSpend,
  formRejectionCapOverride = '',
  onFormRejectionCapOverride,
  saving,
  onSave,
  labels,
  assigneeAutocompleteOptions,
  descriptionEditing,
  onDescriptionEditingChange,
  ticketFormSourceAlertTitle,
  canModifyTicket,
  companyId,
  uid,
  email,
  role,
  userData,
  userByUid,
  agentById,
  formatDateTime,
  timeZoneLabel,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper">
      <DialogTitle>New ticket</DialogTitle>
      <DialogContent dividers sx={{ pt: 1 }}>
        <TicketDetailView
          onClose={onClose}
          editing={null}
          ticketFormReadOnly={ticketFormReadOnly}
          formTitle={formTitle}
          onFormTitleChange={onFormTitleChange}
          formBody={formBody}
          onFormBodyChange={onFormBodyChange}
          formStatus={formStatus}
          onFormStatusChange={onFormStatusChange}
          formPriority={formPriority}
          onFormPriorityChange={onFormPriorityChange}
          formAppId={formAppId}
          onFormAppIdChange={onFormAppIdChange}
          ticketApps={ticketApps}
          forceAppSelection={forceAppSelection}
          formTargetRepoKey={formTargetRepoKey}
          onFormTargetRepoKeyChange={onFormTargetRepoKeyChange}
          formLinkedReadRepoKeys={formLinkedReadRepoKeys}
          onFormLinkedReadRepoKeysChange={onFormLinkedReadRepoKeysChange}
          gameProjectsWithGithub={gameProjectsWithGithub}
          appProjectsWithGithub={appProjectsWithGithub}
          formLabelIds={formLabelIds}
          onFormLabelIdsChange={onFormLabelIdsChange}
          formAssignee={formAssignee}
          onFormAssigneeChange={onFormAssigneeChange}
          formAiSpendOverrideCalls={formAiSpendOverrideCalls}
          onFormAiSpendOverrideCalls={onFormAiSpendOverrideCalls}
          formAiSpendOverrideSpend={formAiSpendOverrideSpend}
          onFormAiSpendOverrideSpend={onFormAiSpendOverrideSpend}
          formRejectionCapOverride={formRejectionCapOverride}
          onFormRejectionCapOverride={onFormRejectionCapOverride}
          saving={saving}
          onSave={onSave}
          labels={labels}
          assigneeAutocompleteOptions={assigneeAutocompleteOptions}
          descriptionEditing={descriptionEditing}
          onDescriptionEditingChange={onDescriptionEditingChange}
          ticketFormSourceAlertTitle={ticketFormSourceAlertTitle}
          ticketSandboxMetaById={{}}
          onViewCodePatches={() => {}}
          canModifyTicket={canModifyTicket}
          companyId={companyId}
          uid={uid}
          email={email}
          role={role}
          userData={userData}
          userByUid={userByUid}
          agentById={agentById}
          formatDateTime={formatDateTime}
          timeZoneLabel={timeZoneLabel}
        />
      </DialogContent>
    </Dialog>
  );
}
